exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".uppercase{text-transform:uppercase}.location-logo{width:200px;height:150px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./client/app/components/admin/entity/edit/edit.styl
// module id = 740
// module chunks = 0